import React, { useState } from 'react';
import { Play } from 'lucide-react';
import thumbnails from '../data/loomThumbnails.json';
import { useLanguage } from '../contexts/LanguageContext';
import { tr } from '../utils/i18n';

// Click-to-play Loom embed: mounting ten iframes at once exhausts browser
// resources (ERR_INSUFFICIENT_RESOURCES) and the players render blank.
export const LoomEmbed = ({ id, label, className = 'w-full h-48' }) => {
  const [active, setActive] = useState(false);
  const { currentLanguage } = useLanguage();
  const thumbnail = thumbnails[id]?.thumbnail;

  if (active) {
    return (
      <iframe
        src={`https://www.loom.com/embed/${id}?autoplay=1&hideEmbedTopBar=true`}
        title={label || `Loom ${id}`}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        className={className}
        data-testid={`loom-iframe-${id}`}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setActive(true)}
      data-testid={`loom-play-${id}`}
      aria-label={`${tr(currentLanguage, 'Lire la vidéo')}${label ? ` — ${label}` : ''}`}
      className={`group relative block ${className} overflow-hidden bg-gray-900`}
    >
      {thumbnail && (
        <img
          src={thumbnail}
          alt={label || ''}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
        />
      )}
      <span className="absolute inset-0 bg-gradient-to-t from-gray-900/70 via-gray-900/10 to-transparent" />
      <span className="absolute inset-0 flex items-center justify-center">
        <span className="w-14 h-14 rounded-full bg-white/95 shadow-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
          <Play className="w-6 h-6 text-blue-600 ml-0.5" fill="currentColor" />
        </span>
      </span>
      <span className="absolute bottom-2 left-3 right-3 text-left text-xs font-medium text-white/90 truncate">
        {tr(currentLanguage, 'Lire la vidéo')}
      </span>
    </button>
  );
};

export default LoomEmbed;
